import { render } from "./TabNav.vue?vue&type=template&id=ca5d9a6c&scoped=true&lang=html"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"

import "./TabNav.vue?vue&type=style&index=0&id=ca5d9a6c&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-ca5d9a6c"

export default script